<div
  #mapElement
  [id]="mapIndex"
  class="ggc-ol-map"
  [attr.tabindex]="mapTabIndex"
  [attr.role]="ariaRole"
  [attr.aria-label]="ariaLabel"
></div>
